
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import OeamtcIcon, { IconProps } from '@components/new-styleguide/icon/OeamtcIcon.vue';
import ChevronRightIcon from '@components/icons/icon-chevron-right.svg';
import IconAdd from '@components/icons/icon-add.svg';
import { RawLocation } from 'vue-router';

export interface ListItem {
  title: string,
  subtitle?: string,
  hoverText?: string,
  location?: RawLocation,
  letterIcon?: IconProps,
  tagIcon?: IconProps,
  switchState?: boolean,
  hasButton?: boolean,
  onSwipeRight?: any,
}

@Component({
  name: 'AppListItem',
  components: {
    OeamtcIcon,
    ChevronRightIcon,
    IconAdd
  }
})
export default class AppListItem extends Vue {
  @Prop({ required: true })
  private value: ListItem;

  @Prop({ default: false })
  private disabled: boolean;

  @Prop({ default: false })
  private extendLineLimit: boolean;

  @Prop({ default: true })
  private showRightIcon: boolean;

  @Prop({ default: false })
  private limitWidth: boolean;

  @Prop({ default: false })
  private isLeftQuickActionsOpen: boolean;

  onClick(event) {
    const isRightClick = event.which === 3 || event.button === 2;
    const isSwitchBeingClicked = event.target === this.$refs.switch;

    if (isSwitchBeingClicked || this.disabled) {
      return;
    } else if (isRightClick || !this.value.location) {
      this.$emit('click');
    } else {
      this.$router.push(this.value.location);
    }
  }

  onSwipeRight() {
    if (!this.hasSwipeSlot) {
      return;
    }

    this.$emit('swipeRight');
  }

  onSwipeLeft() {
    if (!this.hasSwipeSlot) {
      return;
    }

    this.$emit('swipeLeft');
  }

  get hasSwipeSlot() {
    return !!this.$slots.quickActionsLeft;
  }

  onSwitchChange(event) {
    this.$emit('checked', event.target.checked);
  }
}
